import { Col, Skeleton } from "antd";
import React from "react";

function PackageSkeleton() {
  return (
    <>
      <Col md={12} >
        <Skeleton.Button active size="large" />
        <Skeleton
          active
          style={{
            marginBottom: "10px",
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
        </div>
        <br />
        <Skeleton.Input active size="large" />
      </Col>
      <Col md={12}>
        <Skeleton.Button active size="large" />
        <Skeleton
          active
          style={{
            marginBottom: "10px",
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
        </div>
        <br />
        <Skeleton.Input active size="large" />
      </Col>
      <Col md={12} >
        <Skeleton.Button active size="large" />
        <Skeleton
          active
          style={{
            marginBottom: "10px",
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
        </div>
        <br />
        <Skeleton.Input active size="large" />
      </Col>
    </>
  );
}

export default PackageSkeleton;
